
const images = {
    LOGO: require("../assets/Deeze/Logo.png"),
    LOGO2: require("../assets/Deeze/white-letter.png"),
    LOGO3: require("../assets/Deeze/White.jpg"),
    WELCOME: require('../assets/Deeze/welcome.png'),
    NODEJS: require('../assets/Technology/nodejs.png'),
    REACTJS: require('../assets/Technology/reactjs.png'),
    REACT_NATIVE: require('../assets/Technology/reactNative.png'),
    MONGODB: require('../assets/Technology/mongodb.png'),
    TAILWIND: require('../assets/Technology/tailwind.png'),
    FIGMA: require('../assets/Technology/figma.png'),
    AMAZON: require('../assets/Technology/amazon.png'),
    BANNER1: require('../assets/Banner/temp1.png'),
    BANNER2: require('../assets/Banner/temp2.png'),
    BANNER3: require('../assets/Banner/temp3.png'),
    FEATURE1: require('../assets/Feature/image1.png'),
    FEATURE2: require('../assets/Feature/image2.png'),
    FEATURE3: require('../assets/Feature/image3.png'),
    DOWN_ARROW: require('../assets/resources/down-arrow.png'),
    MOBILE: require('../assets/resources/mobile.png'),
    MOBILE1: require('../assets/resources/mobile1.png'),
    MOBILE2: require('../assets/resources/mobile2.png'),
    MOBILE3: require('../assets/resources/mobile3.png'),
    TEAM: require('../assets/resources/team.png'),
    SERVICE_BANNER: require('../assets/Service/banner.png'),
    DEFAULT_SERVICE_IMAGE: require('../assets/Service/default_image.png'),
    DEFAULT_WORKS_IMAGE: require('../assets/resources/project1.png'),
    

  };
  
  export default images;
  